<template>
  <div class="main"  v-redirect-if-no-permission:RESTRICTED_AREA>
    <v-form ref="form" style="max-height: 118px">
      <v-container>
        <div class="title text--primary">
          {{ $t("maps.restrictedAreaEditor.heading") }}
        </div>
        <v-layout>
          <v-flex md2 sm12>
            <v-text-field v-model="data.name" append-icon="edit" :label="$t('common.name')" :rules="[rules.required]" single-line
              hide-details></v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex md2 sm12>
            <v-text-field v-model="data.from" type="datetime-local" :label="$t('common.from')"  :rules="[rules.required]"/>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex md2 sm12>
            <v-text-field clearable v-model="data.to" type="datetime-local" :label="$t('common.to')" />
          </v-flex>

          <v-spacer></v-spacer>
        
          <v-spacer></v-spacer>
          <v-flex md1>
            <v-btn color="primary" dark class="mb-2" @click.stop="dialog = true">{{ $t("common.save") }}</v-btn>
          </v-flex>

          <v-dialog v-model="dialog" max-width="290">
            <v-card>
              <v-card-title class="headline">{{ $t("maps.restrictedAreaEditor.saveChanges") }}</v-card-title>

              <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn color="primary" flat="flat" @click="dialog = false">
                  {{ $t("common.cancel") }}
                </v-btn>

                <v-btn color="primary" flat="flat" @click="save"> {{ $t("common.save") }} </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="diaload" hide-overlay persistent width="300">
            <v-card color="primary" dark>
              <v-card-text>
                {{ $t("maps.restrictedAreaEditor.savingChanges") }}
                <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-layout>
      </v-container>
    </v-form>
    <div id="map"></div>
  </div>
</template>
<script>
import Mapbox from "mapbox-gl";
import MapboxDraw from "@mapbox/mapbox-gl-draw";
import centroid from "@turf/centroid";
import "@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css";
import moment from "moment";

export default {
  name: "RestrictedAreaEditor",
  title() {
    return this.$t("maps.restrictedAreaEditor.title");
  },
 
  data() {
    return {
      mode: "add", // or edit
      baseUri: "restricted-area",
      id: null,
      map: null,
      diaload: false,
      loading: false,
      dialog: false,
      drawComponent: null,
      answer: null,
      center: null,
      polygon: null,
      data: {
        name: null,
        from:  moment().format("YYYY-MM-DD HH:mm"),
        to:  moment().format("YYYY-MM-DD HH:mm")
      },
    };
  },
  mounted() {
    Mapbox.accessToken = this.api.mapBox.accessToken;
    this.center = this.api.mapBox.center;
    if (this.$route.params.id !== undefined) {
      this.mode = "edit";
      this.id = this.$route.params.id;
      this.getData();
    } else {
      this.mode = "add";
      this.loadMap();
    }
  },
  methods: {
  
    loadMap() {
      this.map = new Mapbox.Map(
        Object.assign({ container: "map" }, this.api.mapBox, {
          center: this.center,
        })
      );
      this.drawComponent = new MapboxDraw({
        displayControlsDefault: false,
        controls: {
          polygon: true,
          trash: true,
        },
        styles: [
          {
            id: "gl-draw-polygon-fill-inactive",
            type: "fill",
            filter: ["all", ["has", "user_portColor"]],
            paint: {
              "fill-color": ["get", "user_portColor"],
              "fill-opacity": 0.5,
            },
          },
          {
            id: "gl-draw-polygon-fill-active",
            type: "fill",
            filter: [
              "all",
              ["==", "active", "true"],
              ["==", "$type", "Polygon"],
            ],
            paint: {
              "fill-color": "#fbb03b",
              "fill-outline-color": "#fbb03b",
              "fill-opacity": 0.1,
            },
          },
          {
            id: "gl-draw-polygon-midpoint",
            type: "circle",
            filter: [
              "all",
              ["==", "$type", "Point"],
              ["==", "meta", "midpoint"],
            ],
            paint: {
              "circle-radius": 3,
              "circle-color": "#fbb03b",
            },
          },
          {
            id: "gl-draw-polygon-stroke-inactive",
            type: "line",
            filter: [
              "all",
              ["==", "active", "false"],
              ["==", "$type", "Polygon"],
              ["!=", "mode", "static"],
            ],
            layout: {
              "line-cap": "round",
              "line-join": "round",
            },
            paint: {
              "line-color": "#3bb2d0",
              "line-width": 2,
            },
          },
          {
            id: "gl-draw-polygon-stroke-active",
            type: "line",
            filter: [
              "all",
              ["==", "active", "true"],
              ["==", "$type", "Polygon"],
            ],
            layout: {
              "line-cap": "round",
              "line-join": "round",
            },
            paint: {
              "line-color": "#fbb03b",
              "line-dasharray": "0.2,2",
              "line-width": 2,
            },
          },
          {
            id: "gl-draw-line-inactive",
            type: "line",
            filter: [
              "all",
              ["==", "active", "false"],
              ["==", "$type", "LineString"],
              ["!=", "mode", "static"],
            ],
            layout: {
              "line-cap": "round",
              "line-join": "round",
            },
            paint: {
              "line-color": "#3bb2d0",
              "line-width": 2,
            },
          },
          {
            id: "gl-draw-line-active",
            type: "line",
            filter: [
              "all",
              ["==", "$type", "LineString"],
              ["==", "active", "true"],
            ],
            layout: {
              "line-cap": "round",
              "line-join": "round",
            },
            paint: {
              "line-color": "#fbb03b",
              "line-dasharray": "0.2,2",
              "line-width": 2,
            },
          },
          {
            id: "gl-draw-polygon-and-line-vertex-stroke-inactive",
            type: "circle",
            filter: [
              "all",
              ["==", "meta", "vertex"],
              ["==", "$type", "Point"],
              ["!=", "mode", "static"],
            ],
            paint: {
              "circle-radius": 5,
              "circle-color": "#fff",
            },
          },
          {
            id: "gl-draw-polygon-and-line-vertex-inactive",
            type: "circle",
            filter: [
              "all",
              ["==", "meta", "vertex"],
              ["==", "$type", "Point"],
              ["!=", "mode", "static"],
            ],
            paint: {
              "circle-radius": 3,
              "circle-color": "#fbb03b",
            },
          },
          {
            id: "gl-draw-point-point-stroke-inactive",
            type: "circle",
            filter: [
              "all",
              ["==", "active", "false"],
              ["==", "$type", "Point"],
              ["==", "meta", "feature"],
              ["!=", "mode", "static"],
            ],
            paint: {
              "circle-radius": 5,
              "circle-opacity": 1,
              "circle-color": "#fff",
            },
          },
          {
            id: "gl-draw-point-inactive",
            type: "circle",
            filter: [
              "all",
              ["==", "active", "false"],
              ["==", "$type", "Point"],
              ["==", "meta", "feature"],
              ["!=", "mode", "static"],
            ],
            paint: {
              "circle-radius": 3,
              "circle-color": "#3bb2d0",
            },
          },
          {
            id: "gl-draw-point-stroke-active",
            type: "circle",
            filter: [
              "all",
              ["==", "$type", "Point"],
              ["==", "active", "true"],
              ["!=", "meta", "midpoint"],
            ],
            paint: {
              "circle-radius": 7,
              "circle-color": "#fff",
            },
          },
          {
            id: "gl-draw-point-active",
            type: "circle",
            filter: [
              "all",
              ["==", "$type", "Point"],
              ["!=", "meta", "midpoint"],
              ["==", "active", "true"],
            ],
            paint: {
              "circle-radius": 5,
              "circle-color": "#fbb03b",
            },
          },
          {
            id: "gl-draw-polygon-fill-static",
            type: "fill",
            filter: [
              "all",
              ["==", "mode", "static"],
              ["==", "$type", "Polygon"],
            ],
            paint: {
              "fill-color": "#404040",
              "fill-outline-color": "#404040",
              "fill-opacity": 0.1,
            },
          },
          {
            id: "gl-draw-polygon-stroke-static",
            type: "line",
            filter: [
              "all",
              ["==", "mode", "static"],
              ["==", "$type", "Polygon"],
            ],
            layout: {
              "line-cap": "round",
              "line-join": "round",
            },
            paint: {
              "line-color": "#404040",
              "line-width": 2,
            },
          },
          {
            id: "gl-draw-line-static",
            type: "line",
            filter: [
              "all",
              ["==", "mode", "static"],
              ["==", "$type", "LineString"],
            ],
            layout: {
              "line-cap": "round",
              "line-join": "round",
            },
            paint: {
              "line-color": "#404040",
              "line-width": 2,
            },
          },
          {
            id: "gl-draw-point-static",
            type: "circle",
            filter: ["all", ["==", "mode", "static"], ["==", "$type", "Point"]],
            paint: {
              "circle-radius": 5,
              "circle-color": "#404040",
            },
          },
        ],
      });

      this.map.addControl(this.drawComponent);
      this.map.on("draw.create", this.updateArea);
      this.map.on("draw.delete", this.updateArea);
      this.map.on("draw.update", this.updateArea);
      //   this.center = this.api.mapBox.center;
      // this.marker = new Mapbox.Marker({ draggable: true });
      // this.marker.setLngLat(this.center);
      // this.marker.addTo(this.map);
    },
    getData() {
      this.axios.get(this.baseUri + `/${this.id}`).then(({ data }) => {
        console.log('data');
       
        console.log(data.data);
        const { name, polygon, from, to } = data.data;
        this.center = centroid(polygon).geometry.coordinates;
        this.polygon = data.data.polygon.coordinates[0];
        this.loadMap();
        this.drawComponent.add(polygon);
        this.data.name = name;
        this.data.from =  moment(from).format("YYYY-MM-DD HH:mm");
        this.data.to =  to? moment(to).format("YYYY-MM-DD HH:mm"): null;
      });
    },
    updateArea(e) {
      if (e.type === "draw.create") {
        this.drawComponent.deleteAll();
        this.drawComponent.add(e.features[0]);
      }
    },
    reset() {
      this.drawComponent.deleteAll();
      this.data.name = null;
      this.data.from = null;
      this.data.to = null;
    },
    save() {
      this.data.from =  moment(this.data.from).format("YYYY-MM-DD HH:mm");
      this.data.to = this.data.to ? moment(this.data.to).format("YYYY-MM-DD HH:mm"):null;
      if (this.mode == "edit") {
       
        const polygons = this.drawComponent.getAll().features;
        if (!this.loading && this.$refs.form.validate()) {
          if (polygons.length === 0) {
            alert(this.$t("maps.restrictedAreaEditor.choosePolygon"));
            return;
          }
            this.loading = true;
            this.diaload = true;
            this.dialog = false;

            const polygon = polygons[0].geometry;
         
            const url =
              this.mode === "add" ? this.baseUri : this.baseUri + "/" + this.id;
            (this.mode === "add" ? this.axios.post : this.axios.put)(url, {
              polygon,
              ...this.data,
            })
              .then(() => {
                window.getApp.$emit("SHOW_TOAST", this.$t("maps.restrictedAreaEditor.saved"), "green");
                this.mode === "add" ? this.reset() : null;
              })
              .catch(() =>
                window.getApp.$emit("SHOW_TOAST", this.$t("maps.restrictedAreaEditor.notSaved"), "red")
              )
              .finally(() => {
                this.loading = false;
                this.diaload = false;
              });
          
        }
      }

      if (this.mode == "add") {
        const polygons = this.drawComponent.getAll().features;
        if (!this.loading && this.$refs.form.validate()) {
          if (polygons.length === 0) {
            alert(this.$t("maps.restrictedAreaEditor.choosePolygon"));
            return;
          }
          this.loading = true;
          this.diaload = true;
          this.dialog = false;
         

          const polygon = polygons[0].geometry;
        
          const url =
            this.mode === "add" ? this.baseUri : this.baseUri + "/" + this.id;
          (this.mode === "add" ? this.axios.post : this.axios.put)(url, {
            polygon,
            ...this.data,
          })
            .then(() => {
              window.getApp.$emit("SHOW_TOAST", this.$t("maps.restrictedAreaEditor.saved"), "green");
              this.mode === "add" ? this.reset() : null;
            })
            .catch(() => window.getApp.$emit("SHOW_TOAST", this.$t("maps.restrictedAreaEditor.notSaved"), "red"))
            .finally(() => {
              this.loading = false;
              this.diaload = false;
            });
        }
      }
    },
  },
  computed: {
    rules() {
      return {
        required: (value) => !!value || this.$t("maps.restrictedAreaEditor.requiredRule"),
        number: (value) => isFinite(value) || this.$t("maps.restrictedAreaEditor.mustBeNumber"),
      };
    },
  },
};
</script>

<style scoped>
#map {
  width: 100%;
  height: calc(100vh - 64px - 118px);
}
</style>
